/**
 * Work Experience Data
 * Contains professional work history with achievements and technologies
 */

import type { Experience } from '@/types';
import { WiproLogo, HPELogo } from '../components/logos/CompanyLogos';
import { SUNYBuffaloLogo } from '../components/logos/EducationLogos';
import { MedtronicLogo } from '../components/logos/CompanyLogos';

export const experiences: Experience[] = [
  {
    id: 1,
    title: "Research Assistant",
    company: "University at Buffalo",
    companyLogo: SUNYBuffaloLogo,
    location: "Buffalo, NY",
    date: "January 2025 - April 2025",
    type: "Research",
    achievements: [
      "Developed a real-time traffic sign detection and classification system using YOLO-V11 for object detection and a custom ResNet34-ViT hybrid model (Novelty) for classification, achieving 98.1% accuracy",
      "Built end-to-end pipeline for dataset preprocessing, model fusion, and performance optimization using PyTorch and CUDA",
      "Enhanced system robustness for 55 traffic sign classes under diverse lighting, occlusion, and weather conditions"
    ],
    technologies: ["Python", "PyTorch", "CUDA", "YOLO-V11", "ResNet34", "ViT", "Computer Vision", "Deep Learning"]
  },
  {
    id: 2,
    title: "Software Development Engineer II",
    company: "Wipro Limited",
    companyLogo: WiproLogo,
    location: "Bangalore, India",
    date: "June 2019 - December 2022",
    project: "Medtronic Ltd., Internal",
    projectLogo: MedtronicLogo,
    type: "Full-time",
    achievements: [
      "Reduced feature loading time by 30% by engineering a cross-platform notification tile in C#, Xamarin.Forms, and XAML, featuring asynchronous quick actions to improve user engagement",
      "Increased worker productivity by 20% by developing a full-stack engagement tracker using ASP.NET MVC, building server-side rendered views with HTML and CSS",
      "Managed and optimized CI/CD pipelines in Azure by streamlining Jenkins configurations, consolidated 81% of redundant setups and removed unnecessary steps, improving deployment runtime by 28%",
      "Led DevOps operations for a cross-functional team of twenty developers and twenty testers, ensuring smooth collaboration and efficient project execution using Azure",
      "Decreased API testing workflows from over 1 hour to under 15 minutes per cycle by creating a C# console application to fully automate API response simulation via Postman",
      "Built a PowerShell console app for Azure API calls, seamlessly integrated with Postman, improving API efficiency and reliability while cutting execution time by 70%",
      "Automated Android/iOS behavior testing using Appium and Java Maven, resulting in reduced manual testing efforts and an increase in test coverage by 10%",
      "Owned the end-to-end test automation for mission-critical IoT components by integrating the Robot Framework to validate MQTT protocol communications, ensuring 99.9% system reliability"
    ],
    technologies: ["C#", "XAML", "Xamarin", "ASP.NET", "Azure DevOps", "Jenkins", "Appium", "Java", "Maven", "MQTT", "PowerShell", "Robot Framework"]
  },
  {
    id: 3,
    title: "Intern",
    company: "Hewlett Packard Enterprise",
    companyLogo: HPELogo,
    location: "Chennai, India",
    date: "June 2018 - July 2018",
    type: "Internship",
    achievements: [
      "Interned as an Android Developer developed a Notepad app"
    ],
    technologies: ["Android", "Java"]
  }
];


